"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StorageWithExpiration = /** @class */ (function () {
    function StorageWithExpiration(storage) {
        this.storage = null;
        //default value 2 hours in milliseconds
        this.defaultExpirationTime = 7200000;
        this.expirationKeyPrefix = '__expired_storage__';
        this.storage = storage;
    }
    StorageWithExpiration.prototype.setDataToStorage = function (key, value, expirationTime) {
        if (expirationTime === void 0) { expirationTime = this.defaultExpirationTime; }
        this.storage.setItem(key, value);
        this.setExpirationData(key, expirationTime);
    };
    StorageWithExpiration.prototype.getDataFromStorage = function (key) {
        if (this.isTimeExpired(key)) {
            this.removeDataFromStorage(key);
            return;
        }
        return this.storage.getItem(key);
    };
    StorageWithExpiration.prototype.setExpirationData = function (key, expirationTime) {
        var expirationMoment = new Date();
        this.storage.setItem(this.expirationKeyPrefix + key, expirationMoment.setSeconds(expirationMoment.getSeconds() + expirationTime).toString());
    };
    StorageWithExpiration.prototype.isTimeExpired = function (key) {
        var expiredTime = this.storage.getItem(this.expirationKeyPrefix + key);
        if (expiredTime) {
            var expiredTimeInMs = parseInt(expiredTime, 10);
            return Date.now() > expiredTimeInMs;
        }
    };
    StorageWithExpiration.prototype.removeDataFromStorage = function (key) {
        this.storage.removeItem(key);
        this.storage.removeItem(this.expirationKeyPrefix + key);
    };
    return StorageWithExpiration;
}());
exports.default = StorageWithExpiration;
